import React, { useRef } from 'react'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import DateConverter from '../Tools/DateConverter';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

function GraficaMotosDos(props) {
    const refImg = useRef();
    const { pedidos, valMaximo, tipo, innerRef, color } = props;
    const getColor = (valor) => {
        var P = (valor / valMaximo);
        var R = Math.round(0xFF * (P));
        var G = Math.round(0xFF * (1 - P));
        var B = 0x00;
        return '#' + R.toString(16).padStart(2, '0') + G.toString(16).padStart(2, '0') + B.toString(16).padStart(2, '0');
    }
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        hover: {
            mode: 'dataset',
            interactive: true,
        },
        plugins: {
            legend: {
                display: false,
                position: 'top',
                labels: {
                    color: color == 'n' ? '#fff' : '#000'
                }
            },
            title: {
                display: true,
                text: tipo == 'R' ? 'Grafica Tiempo facturación' : 'Grafica Tiempo Despacho',
                color: color == 'n' ? '#fff' : '#000'
            },
            annotation: {
                annotations: [
                    {
                        type: 'line',
                        mode: 'horizontal',
                        scaleID: 'y-axis-0',
                        value: 70,
                        borderColor: 'red',
                        borderWidth: 2,
                        label: {
                            content: 'Target',
                            enabled: true,
                        },
                    },
                ],
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    color: color == 'n' ? 'white' : 'dark',
                    fontSize: 11,
                }
            },
            x: {
                ticks: {
                    color: color == 'n' ? 'white' : 'dark',
                    fontSize: 11,
                }
            }
        }
    };
    const labels = pedidos.map((item) => DateConverter.formatoHoraSinSegu(tipo == 'R' ? item.LLAMADA_HORA : item.FECHA));
    const data = {
        labels,
        datasets: [
            {
                label: tipo == 'R' ? "Demora Facturación" : "Demora en Despacho",
                data: tipo == 'R' ? pedidos.map((item) => item.DIFF) : pedidos.map((item) => item.RETRASO_DS),
                backgroundColor: tipo == 'R' ? pedidos.map((item) => getColor(item.DIFF)) : pedidos.map((item) => getColor(item.RETRASO_DS)),
                borderColor: tipo == 'R' ? pedidos.map((item) => getColor(item.DIFF)) : pedidos.map((item) => getColor(item.RETRASO_DS)),
                hoverBorderColor: 'blue'
            },
        ],
    }
    const anotationline = {
        id: 'anotationline',
        beforeDraw: chart => {
            console.log(chart)
            if(chart.tooltip._active && chart.tooltip._active.length){
                //refImg.current.beginPath()
                //refImg.current.moveTo(chart.tooltip.x,chart.chartArea.top);
                //refImg.current.lineTo(chart.tooltip.x,chart.chartArea.buttom);
                //refImg.current.lineWidth =10;
                //refImg.current.strokeStyle = 'rgba(0,200,0,0.2)';
                //refImg.current.stroke()
                //refImg.current.restore()
                console.log(chart.chartArea)
            }
        }
    }
    return (
        <div className={`${color == 'n' ? 'bg-dark' : ''} container-fluid w-100`} style={{ height: '400px' }}>
            <Line options={options} data={data} width='100vh' updateMode='resize' plugins={[anotationline]} ref={innerRef==undefined?refImg:innerRef} />
        </div>
    )
}

export default GraficaMotosDos